import VolumeButton from './VolumeButton';

export default VolumeButton;
export * from './types';
